import { usePunditUserContext } from "@/react/contexts/punditUserContext";

import { useBlocksContext } from "../../contexts/BlocksContext";

interface BlockInstanceMetaWithProfileFieldId {
  profileFieldId?: number | null;
}

export const useProfileFieldPrefill = (
  blockInstanceMeta?: BlockInstanceMetaWithProfileFieldId,
) => {
  const { useFormRenderingContext } = useBlocksContext();
  const context = useFormRenderingContext();
  const { currentCommunityMember } = usePunditUserContext();
  const profileFieldValues =
    "profileFieldValues" in context ? context.profileFieldValues : {};
  const profileFieldId = blockInstanceMeta?.profileFieldId;
  const shouldPrefill =
    !context.isPreview &&
    Boolean(profileFieldId) &&
    Boolean(currentCommunityMember);
  const rawPrefillValue =
    shouldPrefill && profileFieldId
      ? profileFieldValues[profileFieldId]
      : undefined;

  return {
    context,
    profileFieldId,
    rawPrefillValue,
  };
};
